// import React, { useEffect, useState } from 'react';
// import {
//   Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
//   Paper, IconButton, Collapse, Box, Typography
// } from '@mui/material';
// import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
// import { getUsers, GetAllProjectPerUser } from '../../api/user.api';
// import { useNavigate } from 'react-router-dom';
// import { Project } from '../../model/project.model';
// import { User } from '../../model/user.model';

// interface CustomerPaymentData {
//   customerName: string;
//   totalPaid: number;
//   totalLeft: number;
//   projects: Project[];
// }

// const Bookkeeping: React.FC = () => {
//   const [data, setData] = useState<CustomerPaymentData[]>([]);
//   const [loading, setLoading] = useState<boolean>(true);
//   const [openRows, setOpenRows] = useState<{ [key: number]: boolean }>({});
//   const [openPayments, setOpenPayments] = useState<{ [key: string]: boolean }>({});
//   const navigate = useNavigate();
//   const role = sessionStorage.getItem("userType");

//   useEffect(() => {
//     if (role !== "מנהל") {
//       navigate("/not-found");
//     }

//     const fetchData = async () => {
//       setLoading(true);
//       const allUsers: User[] = await getUsers();
//       const customers = allUsers.filter((u) => u.userType?.description === 'לקוח');
//       const results: CustomerPaymentData[] = [];

//       for (const customer of customers) {
//         const projects: Project[] = await GetAllProjectPerUser(customer.id);
//         const cleanedProjects = projects.filter(p => p && typeof p === 'object');

//         if (cleanedProjects.length === 0) continue;

//         let totalPaid = 0;
//         let totalLeft = 0;

//         cleanedProjects.forEach((proj) => {
//           totalPaid += proj.pricePaid ?? 0;
//           totalLeft += Number(proj.balance) || 0;
//         });

//         results.push({
//           customerName: `${customer.firstName} ${customer.lastName}`,
//           totalPaid,
//           totalLeft,
//           projects: cleanedProjects
//         });
//       }

//       setData(results);
//       setLoading(false);
//     };

//     fetchData();
//   }, [role, navigate]);

//   const formatCurrency = (amount: number) =>
//     amount.toLocaleString('he-IL', { style: 'currency', currency: 'ILS' });

//   if (loading) return <div>טוען נתונים...</div>;

//   return (
//     <TableContainer component={Paper} sx={{ direction: 'rtl' }}>
//       <Table>
//         <TableHead>
//           <TableRow>
//             <TableCell />
//             <TableCell>שם לקוח</TableCell>
//             <TableCell>שולם</TableCell>
//             <TableCell>נותר לתשלום</TableCell>
//           </TableRow>
//         </TableHead>
//         <TableBody>
//           {data.map((customer, i) => (
//             <React.Fragment key={i}>
//               <TableRow>
//                 <TableCell>
//                   <IconButton
//                     onClick={() =>
//                       setOpenRows(prev => ({ ...prev, [i]: !prev[i] }))
//                     }
//                   >
//                     {openRows[i] ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
//                   </IconButton>
//                 </TableCell>
//                 <TableCell>{customer.customerName}</TableCell>
//                 <TableCell>{formatCurrency(customer.totalPaid)}</TableCell>
//                 <TableCell>{formatCurrency(customer.totalLeft)}</TableCell>
//               </TableRow>

//               <TableRow>
//                 <TableCell colSpan={6} style={{ paddingBottom: 0, paddingTop: 0 }}>
//                   <Collapse in={openRows[i]} timeout="auto" unmountOnExit>
//                     <Box margin={2}>
//                       <Typography variant="subtitle1">פרויקטים:</Typography>
//                       <Table size="small">
//                         <TableHead>
//                           <TableRow>
//                             <TableCell>שם פרויקט</TableCell>
//                             <TableCell>שולם</TableCell>
//                             <TableCell>יתרה</TableCell>
//                             <TableCell>סטטוס</TableCell>
//                             <TableCell />
//                           </TableRow>
//                         </TableHead>
//                         <TableBody>
//                           {customer.projects.map((proj, j) => {
//                             console.log("📌 פרויקט:", proj.businessName);
//                             console.log("🧾 payments:", proj.Payments);

//                             return (
//                               <React.Fragment key={j}>
//                                 <TableRow>
//                                   <TableCell>{proj.businessName}</TableCell>
//                                   <TableCell>{formatCurrency(proj.pricePaid ?? 0)}</TableCell>
//                                   <TableCell>{formatCurrency((proj.totalPrice ?? 0) - (proj.pricePaid ?? 0))}</TableCell>
//                                   <TableCell>{proj.status?.value}</TableCell>
//                                   <TableCell>
//                                     <IconButton
//                                       onClick={() =>
//                                         setOpenPayments(prev => ({
//                                           ...prev,
//                                           [proj.projectId ?? j]: !prev[proj.projectId ?? j]
//                                         }))
//                                       }
//                                     >
//                                       {openPayments[proj.projectId ?? j] ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
//                                     </IconButton>
//                                   </TableCell>
//                                 </TableRow>

//                                 <TableRow>
//                                   <TableCell colSpan={6} style={{ paddingBottom: 0, paddingTop: 0 }}>
//                                     <Collapse in={openPayments[proj.projectId ?? j]} timeout="auto" unmountOnExit>
//                                       <Box margin={2}>
//                                         <Typography variant="subtitle2">תשלומים:</Typography>

//                                         {(!proj.Payments || proj.Payments.length === 0) && (
//                                           <Typography color="text.secondary">אין תשלומים להצגה 🕵️‍♀️</Typography>
//                                         )}

//                                         {proj.Payments && proj.Payments.length > 0 && (
//                                           <Table size="small">
//                                             <TableHead>
//                                               <TableRow>
//                                                 <TableCell>מספר תשלום</TableCell>
//                                                 <TableCell>תאריך</TableCell>
//                                                 <TableCell>סכום</TableCell>
//                                               </TableRow>
//                                             </TableHead>
//                                             <TableBody>
//                                               {proj.Payments.map((payment, k) => {
//                                                 console.log(`💸 תשלום ${payment.paymentNum}:`, payment);
//                                                 return (
//                                                   <TableRow key={k}>
//                                                     <TableCell>{payment.paymentNum}</TableCell>
//                                                     <TableCell>
//                                                       {payment.date
//                                                         ? new Date(payment.date).toLocaleDateString("he-IL")
//                                                         : "אין תאריך"}
//                                                     </TableCell>
//                                                     <TableCell>
//                                                       {typeof payment.amount === "number"
//                                                         ? formatCurrency(payment.amount)
//                                                         : "אין סכום"}
//                                                     </TableCell>
//                                                   </TableRow>
//                                                 );
//                                               })}
//                                             </TableBody>
//                                           </Table>
//                                         )}
//                                       </Box>
//                                     </Collapse>
//                                   </TableCell>
//                                 </TableRow>
//                               </React.Fragment>
//                             );
//                           })}
//                         </TableBody>
//                       </Table>
//                     </Box>
//                   </Collapse>
//                 </TableCell>
//               </TableRow>
//             </React.Fragment>
//           ))}
//         </TableBody>
//       </Table>
//     </TableContainer>
//   );
// };
//export default Bookkeeping;



//  ^ עם 
//  |

//בלי הוספת כל העדכונים של תאריכים 
import React, { useEffect, useState } from 'react';
import { getUsers, GetAllProjectPerUser } from '../../api/user.api';
import { User } from '../../model/user.model';
import { Project } from '../../model/project.model';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Collapse,
  Typography
} from '@mui/material';
// יבוא אייקונים עבור "פלוס" ו"מוקטן" (מינוס)
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

interface CustomerPaymentData {
  customerName: string;
  totalPaid: number;
  totalLeft: number;
  projects: Project[];
}

const Bookkeeping: React.FC = () => {
  const [data, setData] = useState<CustomerPaymentData[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  // ניהול מצב עבור פתיחת/סגירת שורות הטבלה
  const [openRows, setOpenRows] = useState<{ [key: number]: boolean }>({});
  const navigate = useNavigate();
  const role = sessionStorage.getItem("userType");

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const allUsers: User[] = await getUsers();
        const customers = allUsers.filter(user => user.userType?.description === 'לקוח');
        const results: CustomerPaymentData[] = [];

        for (const customer of customers) {
          try {
            const projects: Project[] = await GetAllProjectPerUser(customer.id);
            const cleanedProjects = projects.filter(p => p && typeof p === 'object');
            if (cleanedProjects.length === 0) continue;

            let totalPaid = 0;
            let totalLeft = 0;
            cleanedProjects.forEach(project => {
              totalPaid += project.pricePaid ?? 0;
              totalLeft += Number(project.balance) || 0;
            });

            results.push({
              customerName: `${customer.firstName} ${customer.lastName}`,
              totalPaid,
              totalLeft,
              projects: cleanedProjects,
            });
          } catch (projectError) {
            console.error(`Error in projects for ${customer.firstName}:`, projectError);
          }
        }
        setData(results);
      } catch (error) {
        console.error("General fetchData error:", error);
      } finally {
        setLoading(false);
      }
    };

    if (role !== "מנהל") {
      navigate("/not-found");
    } else {
      fetchData();
    }
  }, [role, navigate]);

  const formatCurrency = (amount: number) => {
    return amount.toLocaleString('he-IL', {
      style: 'currency',
      currency: 'ILS',
    });
  };

  if (loading)
    return <div style={{ textAlign: 'center', padding: '20px' }}>טוען נתונים...</div>;

  return (
    <Box
      sx={{
        marginTop: '100px',         // מרווח מהניו בר
        marginX: 'auto',            // מרכז את התוכן אופקית
        maxWidth: '80%',            // רוחב מוגבל
        padding: 2,
      }}
    >
      <TableContainer
        component={Paper}
        sx={{
          borderRadius: 3,
          boxShadow: 3,
          overflow: 'hidden',
          direction: 'rtl'
        }}
      >
        <h2 style={{ textAlign: 'center' }}>הנהלת חשבונות</h2>
        <Table>
          <TableHead sx={{ backgroundColor: '#1976d2' }}>
            <TableRow>
              <TableCell sx={{ border: 'none' }} />
              <TableCell sx={{ fontWeight: 'bold' }}>שם לקוח</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>שולם</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>נותר לתשלום</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((customer, index) => (
              <React.Fragment key={index}>
                <TableRow
                  sx={{
                    backgroundColor: index % 2 === 0 ? 'background.paper' : '#f9f9f9',
                    '&:hover': { backgroundColor: '#e3f2fd' }
                  }}
                >
                  <TableCell>
                    <IconButton
                      onClick={() =>
                        setOpenRows((prev) => ({ ...prev, [index]: !prev[index] }))
                      }
                      aria-label="expand row"
                    >
                      {openRows[index] ? (
                        <RemoveIcon />  // מציג מינוס כשהשורה פתוחה
                      ) : (
                        <AddIcon />     // מציג פלוס כשהשורה סגורה
                      )}
                    </IconButton>
                  </TableCell>
                  <TableCell sx={{ fontWeight: 500 }}>{customer.customerName}</TableCell>
                  <TableCell>{formatCurrency(customer.totalPaid)}</TableCell>
                  <TableCell>{formatCurrency(customer.totalLeft)}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={6} sx={{ p: 0 }}>
                    <Collapse in={openRows[index]} timeout="auto" unmountOnExit>
                      <Box
                        sx={{
                          m: 2,
                          p: 2,
                          backgroundColor: '#fff',
                          borderRadius: 2,
                          boxShadow: 1
                        }}
                      >
                        <Typography variant="subtitle1" gutterBottom sx={{ borderBottom: '1px solid #ddd', pb: 1 }}>
                          פרטי פרויקטים
                        </Typography>
                        <Table size="small">
                          <TableHead>
                            <TableRow sx={{ backgroundColor: '#eeeeee' }}>
                              <TableCell sx={{ fontWeight: 'bold' }}>שם פרויקט</TableCell>
                              <TableCell sx={{ fontWeight: 'bold' }}>סכום ששולם</TableCell>
                              <TableCell sx={{ fontWeight: 'bold' }}>יתרה</TableCell>
                              <TableCell sx={{ fontWeight: 'bold' }}>סטטוס</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {customer.projects.map((proj, i) => (
                              <TableRow key={i} sx={{ '&:hover': { backgroundColor: '#f1f8ff' } }}>
                                <TableCell>{proj.businessName}</TableCell>
                                <TableCell>{formatCurrency(proj.pricePaid ?? 0)}</TableCell>
                                <TableCell>{formatCurrency((proj.totalPrice ?? 0) - (proj.pricePaid ?? 0))}</TableCell>
                                <TableCell>{proj.status?.value}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </Box>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default Bookkeeping;